import { render, staticRenderFns } from "./right1.vue?vue&type=template&id=ef7d2bce&"
import script from "./right1.vue?vue&type=script&lang=js&"
export * from "./right1.vue?vue&type=script&lang=js&"
import style0 from "./right1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports